import { render, staticRenderFns } from "./Detail1.vue?vue&type=template&id=539c4d57&scoped=true&"
import script from "./Detail1.vue?vue&type=script&lang=js&"
export * from "./Detail1.vue?vue&type=script&lang=js&"
import style0 from "./Detail1.vue?vue&type=style&index=0&id=539c4d57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c4d57",
  null
  
)

export default component.exports